export enum RuleName {
    AlternativeText = 'AlternativeText',
    Contrast = 'Contrast',
    HeadingsHigherLevel = 'HeadingsHigherLevel',
    HeadingsPresence = 'HeadingsPresence',
    HeadingsSequential = 'HeadingsSequential',
    HeadingsStartAtOne = 'HeadingsStartAtOne',
    HtmlBrokenLink = 'HtmlBrokenLink',
    HtmlCaption = 'HtmlCaption',
    HtmlColorContrast = 'HtmlColorContrast',
    HtmlDefinitionList = 'HtmlDefinitionList',
    HtmlEmptyHeading = 'HtmlEmptyHeading',
    HtmlHasLang = 'HtmlHasLang',
    HtmlHeadingOrder = 'HtmlHeadingOrder',
    HtmlHeadingsPresence = 'HtmlHeadingsPresence',
    HtmlHeadingsStart = 'HtmlHeadingsStart',
    HtmlImageAlt = 'HtmlImageAlt',
    HtmlImageRedundantAlt = 'HtmlImageRedundantAlt',
    HtmlLabel = 'HtmlLabel',
    HtmlLinkName = 'HtmlLinkName',
    HtmlList = 'HtmlList',
    HtmlObjectAlt = 'HtmlObjectAlt',
    HtmlTdHasHeader = 'HtmlTdHasHeader',
    HtmlEmptyTableHeader = 'HtmlEmptyTableHeader',
    HtmlTitle = 'HtmlTitle',
    ImageContrast = 'ImageContrast',
    ImageDescription = 'ImageDescription',
    ImageOcr = 'ImageOcr',
    ImageSeizure = 'ImageSeizure',
    LanguageCorrect = 'LanguageCorrect',
    LanguagePresence = 'LanguagePresence',
    Ocred = 'Ocred',
    Parsable = 'Parsable',
    Scanned = 'Scanned',
    Security = 'Security',
    TableHeaders = 'TableHeaders',
    Tagged = 'Tagged',
    Title = 'Title'
}
